export enum SETTINGS_GROUPS {
  EMAIL_SIGNATURE = 0
}

export interface SettingsModalComponentData {
  section: SETTINGS_GROUPS;
}
